import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SessionOidcService } from 'app/services/external/auth-oidc/session-oidc.service';
import { Observable, of } from 'rxjs';
import { StartConfigService } from '../../auth/services/start-config.service';

export const homeResolver: ResolveFn<boolean> = (): Observable<boolean> => {
  const sessionOidcService = inject(SessionOidcService);
  const startConfigService = inject(StartConfigService);

  if (sessionOidcService.currentSessionOidc().isAuthenticated) {
    return startConfigService.initializeConfig();
  }
  return of(false);
};
